export const stripAt = (v: string) => (v || "").trim().replace(/^@+/, "");
export const onlyDigits = (v: string) => (v || "").replace(/\D+/g, "");

export function buildInstagramUrl(raw: string) {
  const handle = stripAt(raw);
  if (!handle) return { ok: false, reason: "Informe seu @ do Instagram" };
  if (!/^[a-z0-9._]{1,30}$/i.test(handle))
    return { ok: false, reason: "@ inválida" };
  return { ok: true, url: `https://instagram.com/${handle}` };
}

export function buildWhatsAppUrl(raw: string) {
  const digits = onlyDigits(raw);
  if (digits.length < 10 || digits.length > 15)
    return { ok: false, reason: "Número inválido" };
  return { ok: true, url: `https://wa.me/${digits}` };
}
